
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import storage from "@/services/storage";
  import DefaultCardImage from "@/components/card/DefaultCardImage.vue";

  @Component({
    components: {
      DefaultCardImage,
    },
  })
  export default class CardImage extends Vue {
    @Prop({ type: String, required: true }) readonly givenName!: string;
    @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
    @Prop({ type: String, default: undefined }) readonly src?: string;
    @Prop({ type: String, default: "User avatar" }) readonly alt?: string;

    filepath: string = "";
    highQualityImageWidth: number = 500;
    highQualityUpdateDate: number = new Date("2022-03-22").getTime();
    imageShown: boolean = false;

    load() {
      if (this.highQuality) {
        this.imageShown = true;
      }
    }

    get imageWidth(): number {
      return (this.$refs.image as HTMLImageElement)?.naturalWidth || 0;
    }

    get imageClasses(): Record<string, boolean> {
      return {
        ["visually-hidden"]: !this.imageShown,
      };
    }

    @Watch("s3FileKey", { immediate: true })
    async getFilePath() {
      if (!this.src) {
        return;
      }

      const profileDate = new Date(this.userUpdatedDate).getTime();

      if (profileDate < this.highQualityUpdateDate) {
        return;
      }

      this.filepath = await storage.get(this.src);
    }

    get isImage(): boolean {
      return Boolean(this.src);
    }

    get highQuality(): boolean {
      return this.imageWidth >= this.highQualityImageWidth;
    }
  }
